import "./bootstrap";

import.meta.glob("../images/**");
import axios from "axios";
import { client } from "laravel-precognition-vue";
import router from "./router/router";
import { createApp } from "vue";
import { createPinia } from "pinia";
import * as Sentry from "@sentry/vue";
import { library } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import {
    faUser,
    faHome,
    faFile,
    faSignOutAlt,
    faChevronRight,
    faChevronLeft,
    faListCheck,
    faGear,
    faTruckFront,
    faUserShield,
    faTruck,
    faTruckPickup,
    faPlusCircle,
    faUsers,
} from "@fortawesome/free-solid-svg-icons";
import App from "@/App.vue";

// Add icons to library
library.add(
    faUser,
    faHome,
    faFile,
    faSignOutAlt,
    faChevronRight,
    faChevronLeft,
    faListCheck,
    faGear,
    faTruckFront,
    faUserShield,
    faTruck,
    faTruckPickup,
    faPlusCircle,
    faUsers,
);

// Check for passive event support
let passiveEvent = false;
try {
    const opts = Object.defineProperty({}, "passive", {
        get: function () {
            passiveEvent = true;
        },
    });
    window.addEventListener("test", () => {}, opts);
} catch (e) {}

// Configure wheel events to be passive by default
if (typeof window !== "undefined") {
    const originalAddEventListener = EventTarget.prototype.addEventListener;
    EventTarget.prototype.addEventListener = function (
        type: string,
        listener: EventListenerOrEventListenerObject,
        options?: boolean | AddEventListenerOptions,
    ) {
        if (type === "wheel" && passiveEvent) {
            if (typeof options === "object") {
                options = {
                    ...options,
                    passive: true,
                };
            } else {
                options = { passive: true };
            }
        }
        return originalAddEventListener.call(this, type, listener, options);
    };
}

const pinia = createPinia();
const app = createApp(App);

// Register FontAwesome component globally
app.component("FontAwesomeIcon", FontAwesomeIcon);

Sentry.init({
    app,
    dsn: window.appConfig.SENTRY_DSN,
    sendDefaultPii: true,
    integrations: [Sentry.captureConsoleIntegration()],
});

client.use(axios);

app.use(pinia);
app.use(router);
app.mount("#app");
